import { BaseURl } from "./BaseApiUrl";


export const getUsersPerformanceWithinDatesAPIURL = BaseURl + "userdetails/getUsersPerformanceWithinDates/v1/";



export const getVeriferPerformanceWithinDatesAPIURL = BaseURl + "userdetails/getVeriferPerformanceWithinDates/v1/";
